import AWS from 'aws-sdk';

// Configure o SDK com suas credenciais e região
AWS.config.update({
    accessKeyId: 'AKIARPHWGINGA3RIQMNP',
    secretAccessKey: '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',
    region: 'sa-east-1',
});

// Crie uma instância de serviço AWS, por exemplo, S3
export const S3 = new AWS.S3();
